const arrayContainsItemWithId = (array, id) => {
  return array.findIndex((item) => item.id === id) !== -1;
};

export { arrayContainsItemWithId };
